var map = {
	"./feature_buy_cn.png": "54ad",
	"./feature_buy_en.png": "2270",
	"./feature_buy_id.png": "630b",
	"./feature_buy_ko.png": "57ec",
	"./feature_buy_ph.png": "d3271",
	"./feature_buy_th.png": "dda5",
	"./feature_buy_zh.png": "3637"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2187";